import { render, staticRenderFns } from "./revertAccountPopup.vue?vue&type=template&id=167dd159&"
import script from "./revertAccountPopup.vue?vue&type=script&lang=js&"
export * from "./revertAccountPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports